<script>
export default {
  methods:{
    _postData(endpoint, dataKey, location, data, callback, ignoreSkip = false){
      if(!ignoreSkip && this.data[location].isLoading === true) {
        //Trying to fixing debouncing problem
        console.log('Skipped Loading Data for store', location)
        return;
      }
      this.data[location][dataKey] = undefined;
      this.data[location].isLoading = true;
      this.data[location].error = false;
      this.$axios.post(endpoint, data).then((r)=>{
        this.data[location][dataKey] = r.data;
        typeof callback === "function" ? callback(location, r) : 1+1;
        this.data[location].isLoading = false;
      }).catch(error => {
        console.log('Error on request', dataKey)
        console.log(error)
        this.data[location].isLoading = false;
        this.data[location].error = true;
      });
    },

    _getData(endpoint, dataKey, location, data, callback){
      if(this.data[location].isLoading === true) {
        //Trying to fixing debouncing problem
        console.log('Skipped Loading Data for store', location)
        return;
      }
      this.data[location][dataKey] = undefined;
      this.data[location].isLoading = true;
      this.data[location].error = false;
      this.$axios.get(endpoint, data).then((r)=>{
        this.data[location][dataKey] = r.data;
        typeof callback === "function" ? callback(location, r) : 1+1;
        this.data[location].isLoading = false;
      }).catch(error => {
        console.log('Error getting data for', location, error)
        this.data[location].isLoading = false;
        this.data[location].error = true;
      });
    },
  },
}
</script>